import { render, staticRenderFns } from "./Tolid.vue?vue&type=template&id=3bbe9982"
import script from "./Tolid.vue?vue&type=script&lang=js"
export * from "./Tolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports